import image from "./assets/rust-test-pattern.jpg";

import * as styles from "./TestPattern.module.css";

const TestPattern: React.FC = () => (
  <img className={styles.container} src={image} />
);

export default TestPattern;
